export default __webpack_public_path__ + "static/media/bg_comunication_mobile.4e8de246.png";